export default {
  tagsDetails: {},
  allTags: {},
};
